import React from 'react';
import LazyLoad from 'react-lazyload';
import Image from '../Image';

export default ({ height, offset, once, ...rest }) => (
  <LazyLoad height={height || 200} offset={offset || 100} once={once || false}>
    <Image {...rest} height={height} />
  </LazyLoad>
);
